__turbopack_context__.v({
  "alt": "checkbox-module-scss-module__rkE2ka__alt",
  "checkbox-container": "checkbox-module-scss-module__rkE2ka__checkbox-container",
  "checkmark": "checkbox-module-scss-module__rkE2ka__checkmark",
  "disabled": "checkbox-module-scss-module__rkE2ka__disabled",
  "error": "checkbox-module-scss-module__rkE2ka__error",
  "label": "checkbox-module-scss-module__rkE2ka__label",
  "light": "checkbox-module-scss-module__rkE2ka__light",
});
